module.exports = __webpack_public_path__ + "img/logo-bb-h.9d249dfa.svg";